import { SectionColor } from './model';

export const SECTION_COLOR_VALUES: Record<SectionColor, string> = {
  grey: '#777777',
  brown: '#845A44',
  orange: '#FF7F48',
  yellow: '#FAC515',
  green: '#16B364',
  blue: '#2E90FA',
  purple: '#835CFE',
  pink: '#F670C7',
  red: '#EF3A3A',
};
export const SECTION_COLOR_TITLE: Record<SectionColor, string> = {
  grey: 'Grey',
  brown: 'Brown',
  orange: 'Orange',
  yellow: 'Yellow',
  green: 'Green',
  blue: 'Blue',
  purple: 'Purple',
  pink: 'Pink',
  red: 'Red',
};
